(function () {
  const dropdown = document.getElementById('kit-select');
  const trigger = document.getElementById('kit-select-trigger');
  const triggerLabel = trigger && trigger.querySelector('.kit-selector__trigger-label');
  const optionsList = document.getElementById('kit-select-options');
  const kitSummary = document.getElementById('kit-summary');
  const kitSummaryText = document.getElementById('kit-summary-text');

  if (!dropdown || !trigger || !optionsList) return;

  const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!productForm) return;

  // Pre-inject the hidden input NOW so it exists in the FormData when ProductForm
  // calls new FormData(form) during its submit handler — appending it in a submit
  // listener fires too late because ProductForm captures FormData synchronously first.
  const kitGroupInput = document.createElement('input');
  kitGroupInput.type = 'hidden';
  kitGroupInput.name = 'properties[_kit_group_id]';
  kitGroupInput.value = '';
  kitGroupInput.setAttribute('data-kit-input', '1');
  productForm.appendChild(kitGroupInput);

  let pendingKit = null;
  let selectedOption = optionsList.querySelector('[data-value=""]');

  function openDropdown() {
    optionsList.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
  }

  function closeDropdown() {
    optionsList.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  }

  function selectOption(li) {
    if (selectedOption) {
      selectedOption.classList.remove('kit-selector__option--selected');
      selectedOption.setAttribute('aria-selected', 'false');
    }

    selectedOption = li;
    li.classList.add('kit-selector__option--selected');
    li.setAttribute('aria-selected', 'true');
    triggerLabel.textContent = li.textContent.trim();
    closeDropdown();

    if (li.dataset.value) {
      // Set a fresh group ID on the pre-injected input.
      // ProductForm's disableBlankInputs() won't touch this because it has a value,
      // so it will be present in FormData when the form submits.
      kitGroupInput.value = `kit-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
      kitSummaryText.textContent =
        `Kit added: ${li.dataset.kitTitle} × ${li.dataset.kitQuantity} (${li.dataset.kitPrice})`;
      kitSummary.style.display = 'block';
    } else {
      // Empty value — ProductForm's disableBlankInputs() will disable this input
      // so it won't appear in FormData (no spurious empty property on the cart item).
      kitGroupInput.value = '';
      kitSummary.style.display = 'none';
    }
  }

  trigger.addEventListener('click', function () {
    if (optionsList.hidden) {
      openDropdown();
    } else {
      closeDropdown();
    }
  });

  optionsList.addEventListener('click', function (e) {
    const li = e.target.closest('.kit-selector__option');
    if (li) selectOption(li);
  });

  document.addEventListener('click', function (e) {
    if (!dropdown.contains(e.target)) closeDropdown();
  });

  trigger.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      optionsList.hidden ? openDropdown() : closeDropdown();
    } else if (e.key === 'Escape') {
      closeDropdown();
    }
  });

  optionsList.addEventListener('keydown', function (e) {
    const options = Array.from(optionsList.querySelectorAll('.kit-selector__option'));
    const idx = options.indexOf(selectedOption);
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      selectOption(options[Math.min(idx + 1, options.length - 1)]);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      selectOption(options[Math.max(idx - 1, 0)]);
    } else if (e.key === 'Escape') {
      closeDropdown();
      trigger.focus();
    }
  });

  productForm.addEventListener('submit', function () {
    const groupId = kitGroupInput.value;

    if (!selectedOption || !selectedOption.dataset.value || !groupId) {
      pendingKit = null;
      return;
    }

    let items = [];
    try {
      items = JSON.parse(selectedOption.dataset.kitItems || '[]');
    } catch (err) {
      items = [];
    }

    if (!items.length) {
      pendingKit = null;
      return;
    }

    pendingKit = {
      groupId,
      items,
      title: selectedOption.dataset.kitTitle,
      quantity: parseInt(selectedOption.dataset.kitQuantity, 10) || 1,
      backgroundQuantity: selectedOption.dataset.kitBackgroundQuantity,
      detailQuantity: selectedOption.dataset.kitDetailQuantity,
      price: selectedOption.dataset.kitPrice,
    };

  });

  window.eventBus.on('cart:added', async () => {

    if (!pendingKit) return;

    const kit = pendingKit;
    pendingKit = null;
    // Clear so a repeat add (without re-selecting a kit) doesn't reuse the same group ID.
    kitGroupInput.value = '';

    const mainQuantityInput = productForm.querySelector('[name="quantity"]');
    const mainQuantity = mainQuantityInput ? parseInt(mainQuantityInput.value, 10) || 1 : 1;

    const cartItems = kit.items.map(function (item) {
      return {
        id: item.variantId,
        quantity: item.quantity * mainQuantity,
        properties: {
          _kit_group_id: kit.groupId,
          _kit_is_child: 'true',
          _kit_title: kit.title,
          _kit_parent_quantity: String(item.quantity),
          _kit_background_quantity: kit.backgroundQuantity,
          _kit_detail_quantity: kit.detailQuantity
        }
      };
    });

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: cartItems })
      });

      window.eventBus.emit('render:cart:drawer');

    } catch (err) {
      console.error('Failed to add kit to cart:', err);
    }
  });

})();
